import React from 'react';
import styled from 'styled-components';
import RentalRep from '../Resources/RenalUnitR.jpg';
import Reno from '../Resources/Renovations.jpg';
import Misc from '../Resources/Misc.jpg';
import CheckView from './Functions/checkView';
import { InView } from 'react-intersection-observer';
import $hanymanIcon from '../Resources/Icons/Handyman.png'
import $drywallIcon from '../Resources/Icons/Drywall.png'
import $exteriorIcon from '../Resources/Icons/Home.png'
import $paintingIcon from '../Resources/Icons/Paint.png'
import $kitchenBathIcon from '../Resources/Icons/KitchenBath.png'
import $propertyIcon from '../Resources/Icons/Property.png'

import $breakImg from '../Resources/AboutSep.jpg'
import $breakImg2 from '../Resources/RenalUnitR.jpg'

const Container = styled.div`
    position: relative;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    display: Flex;
    min-height: 40vh;
    width: ${props => props.mobile ? "100%" : "70vw"};
    margin: auto;
    padding-top: 20px;
    padding-bottom: 20px;
    & p {
        padding: 5px 15px;
        margin:auto;

    }
        & h1{
        font-size: 2em;
        margin: 0;
        }
`
const BlurbSec = styled.div`
    max-width:1000px;
    line-height: 1.8em;
`
const ServiceOverview = styled.div`
    padding-top: 20px;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    padding-bottom: 50px;

    & :hover {
        transition-delay: 250ms;
        scale: 1.15;
    }
`
const OverviewCont = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: ${props => props.mobile ? "90vw" : "400px"};
    min-height: ${props => props.mobile ? "90vw" : "350px"};;
    background: grey;
    margin: ${props => props.mobile ? "10px" : "30px"};
    border-radius: 5px;
    background-image: url("${props => props.$imageurl}");
    background-size: cover;
    backgroun-repeat: no-repeat;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
    
    left: 100px;
    opacity: 1;

    & :hover {
            scale: 1;
        }
`
const OCHeader = styled.div`
    border-radius: 5px 5px 0px 0px;
    background: rgba(255, 255, 255, 0.5);;
`
const OCBody = styled.div`
    bottom:0;
    & p{
        background: rgba(255, 255, 255, 0.7);;

    }
`
const ServicesHeader = styled.div`
    padding: 10px;
    & h2{
        font-size: 2em;
        margin: 0;
        }
`
const Process = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

`
const Pwrap = styled.div`
    width: ${props => props.mobile ? "90vw" : "350px"};

    height: ${props => props.mobile ? "90vw" : "350px"};
    margin: auto;

    & h1{
        color: #3F2064;
        font-size: ${props => props.mobile ? "4rem" : "4.5rem"};
        margin-bottom: 40px ;
        }
    & h3{
        font-size: ${props => props.mobile ? "1.2rem" : "1.4rem"};
        }
    & p{
        font-size: 1.2rem;
        }
`
const ServiceItem = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    max-width: 95vw;
    width: ${props => props.$mobile ? "95vw" : "20vw"};
    margin: 1vw;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    padding: 5px;

    & h1{
    pointer-events: none;
    }
`
const ServiceIcon = styled.div`
    width: ${props => props.$mobile ? "60vw" : "10vw"};
    height: ${props => props.$mobile ? "60vw" : "10vw"};
    background-image: url("${props => props.icon}");
    background-size: cover;
    background-position: center;
    pointer-events: none;
`
const services = [
    {
        name: 'Handyman',
        text: 'HandySham’s reliable handyman services make home and office maintenance a breeze. Whether you need a faucet fixed, furniture assembled, or weatherstripping installed, our professional team ensures every job is done efficiently and to the highest standard.',
        items: [
            'Furniture Aseembly', 'Tv Mounting', 'Door Handles', 'Caulking', 'Door Repairs', 'Flooring', 'Shelves', 'Decore', 'more..'
        ],
        icon: $hanymanIcon,
    },
    {
        name: 'Drywall',
        text: 'For drywall repairs done right, trust HandySham. From fixing small cracks to patching large holes, our experienced professionals ensure your walls look as good as new. No matter the cause—be it wear and tear, damage, or renovation work—we’re here to restore your walls quickly and efficiently.',
        items: [
            'Patches', 'Taping & sanding', 'Water Damage Repairs', 'Ceiling & Wall Repairs', 'Drywall Hanging', 'more..'
        ],
        icon: $drywallIcon
    },
    {
        name: 'Exterior',
        text: 'Exterior Home Repairs Made Easy. We handle the hard work so you can relax and enjoy the comfort of a well-maintained, beautiful home. Our expert services are designed to restore your space and align it with your needs, giving you lasting peace of mind',
        items: [
            'Decks', 'Fencing', 'Porches', 'more..'
        ],
        icon: $exteriorIcon
    },
    {
        name: 'Painting',
        text: 'Your home reflects who you are, and HandySham is here to enhance its charm. Our professional painting services combine exceptional quality and attention to detail to bring your vision to life. From individual room updates to complete home transformations, we believe your home should mirror your unique style and values.',
        items: [
            'Trim & Doors', 'Walls', 'Trim', 'Staining', 'Concrete'
        ],
        icon: $paintingIcon
    },
    {
        name: 'Kitchen & Bathrooms',
        text: 'At HandySham, we believe in turning your house into a home. We take pride in delivering personalized services that cater to your specific needs. From concept to completion, our team works with you to create a kitchen or bath that fits your lifestyle and exceeds your expectations',
        items: [
            'Tiles', 'Grout', 'Caulking', 'Leaks', 'Remodels', 'Plumbing', 'Sinks', 'Accessories', 'more..'
        ],
        icon: $kitchenBathIcon
    },
    {
        name: 'Property Management',
        text: 'Managing a property can be a daunting task, especially when property management companies are reluctant to take on the smaller but necessary maintenance duties. Whether it’s an Airbnb, real estate, or commercial property, we understand that fast and efficient turnovers are key to success.',
        items: [
            'Short Term Rental Repairs', 'Makeovers', 'Maintenance plans', 'more..'
        ],
        icon: $propertyIcon
    }
]
const ServiceList = styled.div`
    display: block;
    font-size: 1.1rem;
    pointer-events: none;
    padding-bottom: 5px;
`
const BreakImg = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    
    width: ${props => props.$mobile ? "95vw" : "80vw"};
    height: 15vh;
    background-image: url("${props => props.img}");
    border-bottom: solid 10px purple;
    background-position: center;
    background-size: cover;
    margin-top: 5vh;
    margin-bottom: 2vh;
    & h3{
    margin: 0;
    }
`
const BgC = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: rgba(100, 0, 194, 0.2);
    border: solid 10px white;
    color: white;
`
function About(props) {
    return (
        <Container id='AboutContainer' $mobile={props.$mobile}>
            <h1>Reliable Fast Repiar & Renovation Services</h1>
            <BlurbSec>
                <p>
                    Welcome to HandySham, your trusted Toronto handyman service for all your repair,
                    maintenance, and improvement needs. Whether you're navigating a fast-paced city
                    life, managing a busy household, or running a business, our skilled team is here
                    to keep your property in top shape. We understand how hard it can be to find time
                    for home projects, which is why we offer reliable, professional services tailored
                    to your schedule—making life a little easier, one task at a time.
                </p>
            </BlurbSec>
            <br /><br />

            {/*----------What we Do--------------*/}
            <BreakImg $mobile={props.$mobile} img={$breakImg2}>
                <BgC>
                    <h1>Just some of what we do.</h1>
                </BgC>
            </BreakImg>

            <BlurbSec>
                <p>
                    At HandySham, we know your time is precious. That’s why we provide flexible scheduling
                    and dependable service you can count on. From routine maintenance to major repairs,
                    our experienced team has the skills and expertise to get the job done right the first
                    time. Offering a wide range of handyman services in Toronto, we’re equipped to assist
                    busy families, professionals, and business owners alike—no task is too big or small for
                    our dedicated team.
                    <br /><br />
                    Our services cover a wide variety of neighborhoods. Don’t see yours listed? Reach out to confirm if we can assist in your area!
                </p>
            </BlurbSec>
            {/*----------Service Overview--------------*/}
            <h1>Services</h1>
            <ServiceOverview>
                {services.map((item, i) => {
                    return (
                        <ServiceItem key={i} $mobile={props.$mobile}>
                            <ServiceIcon icon={item.icon} $mobile={props.$mobile} />
                            <h1> {item.name}</h1>
                            <ServiceList $mobile={props.$mobile}>
                                {item.items.map((item, i) => {
                                    if (i < 3)
                                        return (
                                            <div key={'item'+i}>{item}</div>
                                        )

                                })}
                                & more...
                            </ServiceList>
                        </ServiceItem>
                    )
                })}
            </ServiceOverview>
            {/*----------Steps--------------*/}
            <ServicesHeader>
                <BreakImg $mobile={props.$mobile} img={$breakImg}>
                    <BgC>
                        <h1>How It Works</h1>
                    </BgC>
                </BreakImg>
            </ServicesHeader>

            <Process>
                <Pwrap mobile={props.mobile}>
                    <h1>Step 1:</h1>
                    <h3>Tell Us What You Need</h3>
                    <p>We’ll discuss your project, listen to your needs, and provide an accurate estimate upfront.</p>
                </Pwrap>
                <Pwrap mobile={props.mobile}>
                    <h1>Step 2:</h1>
                    <h3> Convenient Scheduling</h3>
                    <p>
                        Choose a time that fits your schedule—we’ll work around your availability.
                    </p>
                </Pwrap>
                <Pwrap mobile={props.mobile}>
                    <h1>Step 3: </h1>
                    <h3>Effortless Service</h3>
                    <p>Our experienced handyman will complete the work efficiently and on time.</p>
                </Pwrap>
                <Pwrap mobile={props.mobile}>
                    <h1>Step 4: </h1>
                    <h3>Satisfaction Guaranteed</h3>
                    <p>We’ll review the completed work with you to ensure every task meets the highest standard before we leave.</p>
                </Pwrap>
            </Process>
            {/*----------Service Area--------------*/}
        </Container>
    );
}

export default About;